// extracted by mini-css-extract-plugin
export var card = "_50-0";
export var content = "_50-1";
export var contentLoading = "_50-2";